import { AppRoutePath } from 'config/constants';
import { matchPath } from 'react-router-dom';

export const toDisplayCase = (s: string) =>
  s.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
export const QS_CURRENT_CASE_ID = 'current';

// Cache on href since useCurrentCaseId/useWorklistId call this on every render of many components.
let cachedHref: Nullable<string> = null;
let cachedSmid: Nullable<string> = null;
export const getWardCaseSmidFromQueryParams = (): Nullable<string> => {
  const href = window.location.href;
  if (href === cachedHref) return cachedSmid;
  cachedHref = href;
  try {
    cachedSmid = new URL(href).searchParams.get(QS_CURRENT_CASE_ID);
  } catch (e) {
    cachedSmid = null;
  }
  return cachedSmid;
};

/** Returns the case ID only if the current path is the WARD path */
export const getWARDCaseId = (): Nullable<string> => {
  const caseId = getWardCaseSmidFromQueryParams();
  if (isWardRoute() && caseId) return caseId;
  return null;
};

/** Returns true if the current path is the WARD route */
export const isWardRoute = (): boolean =>
  !!matchPath(AppRoutePath.VIEWER_WARD, window.location.pathname);
